import { render, staticRenderFns } from "./ModalOnboardingTerms.vue?vue&type=template&id=a384ccda&"
import script from "./ModalOnboardingTerms.vue?vue&type=script&lang=js&"
export * from "./ModalOnboardingTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports